export default "__VITE_ASSET__DsBZdwWc__"